export default __webpack_public_path__ + "static/media/tram.15983793.svg";